




































































































import VueOptions from '@utils/VueOptions'
import Modal from '@/components/Modal'
import MediaCard from './MediaCard'
import MediaSorter from './MediaSorter'

settings =
  name: 'MediaSelector'

  resources:
    marketplace_media_kit:
      resourceName: 'marketplace_media_kit'
      slug: 'media_kit'

  vue:
    props: ['show', 'media', 'selectedKeys', 'tags', 'actions', 'options']
    components: { Modal, MediaCard, MediaSorter }

    data: ->
      isUploading: false
      activeTab: Object.keys(@media || {})[0] || 'marketplace'
      selectedDefaultTags: []
      selectedCustomTags: []
      search: ''
      form:
        keys: []

      dialog:
        visible: false
        imageUrl: null

    computed:
      title: -> @options?.title || 'Your Media Library'
      description: -> @options?.description || 'Manage your campaign media and photos'
      multi: -> @options?.multi || true
      uploadPath: ->
        url = new URL "#{process.env.VUE_APP_API_ENDPOINT}/uploads/media_kit/#{@mediaKits[@activeTab]?.id}/promotable_photo"
        if @tags?.length
          query = new URLSearchParams()
          query.append 'tags[]', tag for tag in @tags
          url.search = query.toString()
        url.toString()

      mediaKits: ->
        kits = {}
        kits[name] = kit for name, kit of @media when kit?.id
        kits['marketplace'] = @marketplace_media_kit if @marketplace_media_kit?.id
        kits

      tabs: -> Object.keys(@mediaKits || {})

      selectedTags: -> [...@selectedDefaultTags, ...@selectedCustomTags]
      defaultTagOptions: -> [
        { label: 'Venue', value: 'venue' },
        { label: 'Product Sampling', value: 'product_sampling' },
        { label: 'Onsite Space', value: 'onsite_space' },
        { label: '16 x 9', value: '16x9' },
        { label: '4 x 3', value: '4x3' },
      ]
      customTagOptions: ->
        options = {}
        defaultTags = @defaultTagOptions.map((tag) -> tag.value)
        for name, kit of @mediaKits
          for item in kit.media
            for tag in item.tags
              continue if tag in defaultTags
              options[tag] = { label: @format('title', tag), value: tag }
        Object.values(options)

      hasFilter: -> !!@search?.trim() || !!@selectedTags.length

      filteredMedia: ->
        filtered = {}
        for name, kit of @mediaKits
          filtered[name] = kit.media.filter(@mediaMatchFilters) if @hasFilter
          filtered[name] ||= kit.media
        filtered

      selectedMedia: ->
        urls = []
        for key in @form.keys
          for name, kit of @mediaKits
            media = kit.media.find((media) -> media.id is key || media.url is key)
            urls.push media if media and !urls.includes(media.url)
        urls

    methods:

      hiToggleMediaSelection: (media) ->
        if @isMediaSelected media
          @hiUnselect media
        else
          @hiSelect media

      hiSelect: (media) ->
        @form.keys.push media.url

      hiUnselect: (media) ->
        @form.keys = @form.keys.filter((key) => key isnt media.url)

      hiClear: ->
        @form.keys = []

      hiDone: ->
        @done()
        @close()

      hiPreview: (media) ->
        @dialog.visible = true
        @dialog.imageUrl = media.url

      close: -> @$emit('update:show', false)

      canUpload: (tab) -> @currentMemberIsSuperUser() || tab isnt 'marketplace'
      isMediaSelected: (media) -> media.url in @form.keys 
      remove: (media) -> @actions?.onRemove?(media)
      done: -> @actions?.onDone?([...@form.keys])

      beforeUpload: ->
        @isUploading = true

      onUpload: (response, file) ->
        @isUploading = false
        @fetch 'marketplace_media_kit' if @activeTab is 'marketplace'
        @actions?.onUpload?(file)
        @hiSelect response.photo

      addAttachment: (file) ->
        @uploadFile @uploadPath, file.file

      mediaMatchFilters: (item) ->
        @mediaMatchSearch(item) and @mediaMatchTags(item)
      
      mediaMatchSearch: (item) ->
        query = new RegExp(@search?.trim(), 'i')
        query.test item.title

      mediaMatchTags: (item) ->
        tags = Object.values(@selectedTags)
        !tags.find((tag) -> tag not in item.tags)

    watch:
      show: (value) ->
        @form.keys = [...(@selectedKeys || [])] if value

export default VueOptions.vue settings
